import { Carousel } from './carousel/carousel'
import styles from './explore-our-evs.module.css'
import sharedStyles from '../../landing-feature-electric-cars.module.css'
import { useLatestVehicles } from '@cinch-nx/landing-ui-shared'
import { Primary } from '@cinch-labs/design-system'

const handleClick = () => {
  window.open('https://www.cinch.co.uk/used-cars/electric-fuel-type', '_blank')
}

export const ExploreEvs = () => {
  const { data, error } = useLatestVehicles({
    fuelType: 'Electric',
    numberOfVehicles: 6,
  })

  if (!data || error) {
    console.error(error)
    return null
  }

  if (data.vehicleListings.length === 0) {
    return null
  }

  return (
    <section>
      <h3 className={sharedStyles.heading}>Explore our EVs</h3>
      <Carousel
        carouselName="electric-vehicles-carousel"
        vehicles={data.vehicleListings}
      />

      <div className={styles.buttonWrapper}>
        <Primary type="submit" data-testid="ev-button" onClick={handleClick}>
          Browse our electric cars
        </Primary>
      </div>
    </section>
  )
}
